<template lang="pug">
  .component-reveal-void
    ModalReveal
      button.button.danger(slot="trigger") Related Transactions
      .header(slot="header")
        h2 Transactions &nbsp;
          strong INV{{invoice.internal_id}}({{invoice.id}})
      base-list(:component="component", :data-loader="dataLoader")
</template>
<script type="text/babel">
  import ModalReveal from '../../../foundation/ModalReveal'
  import InputSwitch from '../../InputSwitch'
  import ActionButton from '../../ActionButton'
  import Transaction from '../../../../backoffice/Transaction'
  import BaseList from '../../../../../pages/backoffice/BaseList'

  export default {
    name: 'InvoiceTransactions',
    components: {BaseList, Transaction, ActionButton, InputSwitch, ModalReveal},
    data() {
      return {
        component: require('../../../../backoffice/Transaction')
      }
    },
    created() {
    },

    methods: {
      dataLoader(callback) {
        callback(this.transactions)
      }
    },
    computed: {
      transactions() {
        return {
          current_page: 1,
          per_page_count: 10000,
          current_page_count: 1,
          items: this.invoice.transactions,
          items_count: this.invoice.transactions.length,
          page_count: 1,
        }
      }
    },
    props: ['buttons', 'invoice'],
  }
</script>
<style lang="sass" rel="stylesheet/sass">
  .component-reveal-void
    .modal-footer
      .footer
        display: flex
        justify-content: space-around
</style>



// WEBPACK FOOTER //
// InvoiceRevealTransactions.vue?58f81152